import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { ApiCall } from "@shared/async-services/http/api-call.service";
import { LoaderService } from "@shared/async-services/loader/loader.service";
import { ConfirmDialogComponent } from "@shared/confirm-dialog/confirm-dialog.component";
import { BroadCastServiceService } from "@shared/services/broad-cast-service.service";
import storageService from "@shared/storage/storageService";
import { OwlOptions } from "ngx-owl-carousel-o";
import { ToastrService } from "ngx-toastr";


@Component({
  selector: "app-assigned-accountant",
  templateUrl: "./assigned-accountant.component.html",
  styleUrls: ["./assigned-accountant.component.scss"],
})
export class AssignedAccountantComponent implements OnInit {
  data: any[];
  roles: any[];
  accountantId: any;
  userId: any;
  accountantList: any = [];
  default = "/assets/images/user.jpg";
  interval : any; 
  showSpinner : boolean  = false;
  userSessionChecker = 5000;
  selectedLanguage = "";
  message : any;
  accountantData : any;
  dialogRef: any; 
  currentUser: any = {};


  constructor(
    private broadCast: BroadCastServiceService,
    private auth: ApiCall,
    public loader: LoaderService,
    public router: Router,
    private toastr: ToastrService,
    private dialog: MatDialog,
    public translate: TranslateService
    ) {}

  ngOnInit(): void {
    this.currentUser = storageService.getItemAsJSON("currentUser");
    this.setLanguage();
    this.broadCast.sendMessage("Assign-Accountants");
    this.userId = storageService.getItem("userId");
    this.getUserAccountants();

    this.interval = setInterval(() => {
      this.getCurrentUser();
    }, this.userSessionChecker);
  }

  setLanguage() {
    this.auth.getSelectedLanguage(this.currentUser.id).subscribe(
      (response: any) => {
        this.translate.use(response.data.shortName);
      },
      (error) => {
        console.error("API error, ", error);
      }
    );
  }

  ngOnDestroy() {
    if (this.interval) {
        clearInterval(this.interval);
    }
   }

   canLogout() {
     try {
          this.translate.get(['CONFIRMATION.MESSAGE'])
          .subscribe(translations => {
          this.message = translations['CONFIRMATION.MESSAGE'];
        });
        history.pushState("","","/#/assign-accountants");
        this.dialogRef = this.dialog.open(ConfirmDialogComponent, {
          maxWidth: "400px",
          data: {
            title: "Logout",
            message: this.message,
          },
        });
        return this.dialogRef.afterClosed();
     } catch (error) {
       console.error("Error while deactivating the component, ", error);
     }
   }

   getCurrentUser() {
    this.auth.getCurrentUser().subscribe((res: any) => {
      if(res.data?.active){
        storageService.setItemAsJSON("currentUser", res.data);
      }else{
        if (this.interval) {
          clearInterval(this.interval);
        }
        storageService.setItemAsJSON("currentUser", null);
        storageService.clearItem("token");
        storageService.clearItem("currentUser");
        storageService.clearItem("userId");
        storageService.clearItem("accountant");
        storageService.clearItem("accountant-bio");
        storageService.clearItem("appoinment");
        storageService.clearItem("acc-appoinment");
        storageService.clearItem("ca-appoinment");
        storageService.clearItem("questionMetadata");
        this.router.navigate(["landing-page"]);
      }
    });
  }


  onBtnClick(accountant: any) {
    try {
      this.router.navigate(["client/questionarie-flow"]);
      storageService.setItemAsJSON('accountant',accountant);
    } catch (e) {
      console.log("Error while making appointment",e);
      this.toastr.error("Error while making appointment!", "", {
        timeOut: 3000,
      });
    }
  }

  accountantBio(accountant:any){
  try {
    this.router.navigate(["client/bio-page"]);
    storageService.setItemAsJSON('accountant-bio',accountant);
  } catch (error) { 
  }
}
  makeAppoinment(){
  this.router.navigate(["client/make-appoinment"]);
  }
  giveFeedback(){
    this.router.navigate(["client/feedback"]);
    }

  getUserAccountants() {
    this.showSpinner = true;
    this.auth.getUserAccountants(this.userId).subscribe((res: any) => {
      try {
    this.showSpinner = false;
    this.accountantList = res.data.filter(obj => obj.accountant.active);
        this.broadCast.childDataChanges(this.accountantList.length);
        this.accountantList.forEach(accountant => {
          this.accountantData = accountant;
             if (this.accountantData.accountant && this.accountantData.accountant.avtar) {
              this.accountantData.accountant.avtar = "data:image/jpeg;base64," +  this.accountantData.accountant.avtar;
          }else{
            this.accountantData.accountant.avtar = this.default;
          }
        });
      } catch(e) {
        console.log("Error while getting the accountants ",e);
      }
    });
  }

  // Carousel
  customOptions: OwlOptions = {
    loop: false,
    items: 3,
    autoWidth: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 700,
    center: false,
    navText: [
      '<i class="fas fa-caret-left"></i>',
      '<i class="fas fa-caret-right"></i>',
    ],
    responsive: {
      0: {
        items: 3,
      },
      740: {
        items: 3,
      },
      940: {
        items: 3,
      },
    },
    nav: true,
  };
}
